<!-- 密钥下发记录查询 -->
<template>
  <div class="page">
    <div
      class="paginations"
      :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }"
    >
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 防止输入框回车刷新页面 -->
          <el-form-item label="" v-show="false">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="zyk_key：">
            <el-input
              size="small"
              v-model="searchData.zykKey"
              placeholder="请输入zyk_key"
            />
          </el-form-item>
          <el-form-item label="资源库名称：">
            <el-input
              size="small"
              v-model="searchData.zykName"
              placeholder="请输入资源库名称"
            />
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search()"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
              <div class="addition">
                <el-button @click="exportData">导出</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="table_box">
        <el-table :data="tableObj.list" id="out-table">
          <el-table-column prop="zykKey" label="zyk_key" align="center" />
          <el-table-column prop="zykId" label="zykId" align="center" />
          <el-table-column
            prop="zykName"
            label="资源库名称"
            align="center"
          />
          <el-table-column
            prop="firstChargeUnit"
            label="第一主持"
            align="center"
          />
          <el-table-column prop="url" label="url" align="center" />
          <el-table-column
            prop="flag"
            label="是否关联三级两平台"
            align="center"
          />
        </el-table>
        <pageNumber
          :paginations="7"
          :pageNum="searchData.pageDto.pageNum"
          :page-size="searchData.pageDto.pageSize"
          :total="tableObj.total"
          :jumpTo="tableObj.jumpTo"
          @currentChange="search"
        ></pageNumber>
      </div>
    </div>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import pageNumber from "@/components/pageNumber.vue"; //分页
import * as XLSX from "xlsx";
export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      // 查询条件
      searchData: {
        zykKey: "",
        zykName: "",
        pageDto: {
          pageNum: 1, //当前显示的页面页码数
          pageSize: 10,
        },
      },
      // 表格数据
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    // 查询表格
    search(page) {
      this.searchData.pageDto.pageNum = page ? page : 1;
      this.tableObj.jumpTo = page ? page : 1;
      this.$axios
        .post(this.$apiurls.getDistributeDetails, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableObj.list = res.data.list;
            this.tableObj.total = res.data.total;
          }
        });
    },
    // 重置表格
    reset() {
      this.searchData.zykKey = "";
      this.searchData.zykName = "";
      this.search();
    },
    exportData1() {
      let wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
      const wscols = [
        // 定义每列的宽度 我这里是16列
        { wch: 19 },
        { wch: 19 },
        { wch: 50 },
        { wch: 19 },
        { wch: 19 },
        { wch: 19 },
      ];
      wb.Sheets[wb.SheetNames[0]]["!cols"] = wscols;
      /* 获取二进制字符串作为输出 */
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
        align: "center",
        valign: "vcenter",
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          `任务进度规划.xlsx`
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    // 点击导出
    exportData() {
      this.$axios
        .post(this.$apiurls.exportDistributeDetails, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res) {

            let blob = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8",
            });
            const link = document.createElement("a");
            link.download = "下发详情"; //定义表格名称，后缀是文件格式
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          }
        });
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped>
</style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped>
</style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
}

::v-deep .el-form {
  height: 100%;

  .el-textarea {
    .el-textarea__inner {
      font-family: initial;
    }
  }
}

.pop_up ::v-deep .el-dialog__body {
  max-height: 600px;
}

.el-tree {
  max-height: 550px;
  overflow: auto;
}

.el-tree,
::v-deep.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content,
::v-deep .el-tree-node:focus > .el-tree-node__content {
  background: transparent;
  color: #c0c4cc;
}

.el-tree ::v-deep .el-tree-node__content:hover {
  background: #203058 !important;
  color: #fff;
}

.table_box {
  // max-height: calc(100% - 60px);
  margin-bottom: 0;
}
</style>
<style lang="scss">
.zyk-content {
  width: calc(100% - 50px);
  margin-left: 20px;
  min-height: 100px;
  max-height: 200px;
  overflow: auto;
  border: 1px solid rgba(86, 94, 121, 0.59);
  background-color: rgba(86, 94, 121, 0.59);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 15px;

  .item {
    margin-right: 20px;
    color: #fff;
  }
}

.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: rgba(26, 38, 72);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;

  .el-select-dropdown__list {
    box-sizing: border-box;
    padding: -1px 0;
    background: rgba(26, 38, 72) !important;

    .el-select-dropdown__item {
      color: #fff !important;
    }

    .hover,
    .el-select-dropdown__item:hover {
      background: transparent;
      border: 1px solid rgba(27, 246, 248);
    }

    .el-select-dropdown__item:hover span {
      font-size: 14px;
      transform: scale(1);
    }

    .selected {
      color: rgba(27, 246, 248);
    }
  }

  .popper__arrow,
  .popper__arrow::after {
    position: absolute;
    display: "";
    width: "";
    height: "";
    border: none;
    border-style: "";
  }
}

.el-input__inner {
  background: rgba(86, 94, 121, 0.59);
  border-color: rgba(86, 94, 121, 0.59);
  color: #fff;
}

.el-icon-refresh,
.el-icon-upload,
.el-icon-view {
  font-size: 18px !important;
  color: #1bf6f8 !important;
  margin-right: 5px;
  cursor: pointer;
}
</style>

